import axios from "axios";
import { llmUrl } from '../utils/config';
const api = axios.create({ baseURL: llmUrl });

api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("token");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const getFiles = (page = 1, archived = false, filterQuery) =>
  api.get(`/pdf-manuals?page=${page}&archived=${archived}&${filterQuery}`);

export const uploadFiles = (formData) => api.post(`/pdf-manuals`, formData);

export const archiveFiles = (data) => api.patch(`/pdf-manuals/archive`, data);

export const deleteFiles = (data) => api.post(`/pdf-manuals/bulk`, data);

export const dashboardData = () => api.get(`/pdf-manuals/dashboard`);

export const updateFiles = (formData, id) =>
  api.put(`/pdf-manuals/${id}`, formData);

export const getFaqs = (page = 1) => api.get(`/faqs?page=${page}`);

export const approveFaq = (data) => api.patch(`/faqs/archive`, data);

export const prepareJsonl = () => api.get(`/faqs/jsonl`);

export const getTrainingFile = (page = 1) =>
  api.get(`/training-files?page=${page}`);

export const refreshFinetuneSatus = (fileId, id, status) =>
  api.get(`/training-files/refresh/${id}?fileid=${fileId}&status=${status}`);

export const fineTune = (formData) =>
  api.post(`/training-files/finetune`, formData);

export const generateSinglePreSignedUrl = (data) => api.post(`/pdf-manuals/generate-single-presigned-url`, data);

export const startMultipartUpload = (data) => api.post(`/pdf-manuals/start-multipart-upload`, data);

export const generatePresignedUrl = (data) => api.post(`/pdf-manuals/generate-presigned-url`, data);

export const completeMultipartUpload = (data) => api.post(`/pdf-manuals/complete-multipart-upload`, data);

export const saveFiles = (data) => api.post(`/pdf-manuals/save`, { data });

export const removeFromIndexAndBucket = (id) => api.put(`/pdf-manuals/remove/${id}`, {});

export const validateFile = (data) => api.post(`/pdf-manuals/validate`, { data });

export const downloadFile = (id) => api.get(`/pdf-manuals/download/${id}`);

export default api;
